export enum TourStopSource {
    PLANNING = 'planning',
    DRIVE = 'drive',
}
